<template>
  <div class="pagesContent">
      <el-container>
        <el-header height="100px">
          <el-card>
            <el-row>
              <el-col :span="22">
                <h4><i class="el-icon-notebook-2"></i>  版本类型</h4>
              </el-col>
              <el-col :span="2">
                  <el-button type="primary" size="medium" icon="el-icon-plus" @click="toAdd">添加</el-button>
              </el-col>
            </el-row>
          </el-card>
        </el-header>
        <el-main class="main-box">
          <el-card>
            <!-- 员工表格  条纹 stripe 边框 border   @row-dblclick="exitRowVersion"  -->
            <el-table style="width: 100%;" highlight-current-row
                     :data="versionTypeData"
                     :row-class-name="tableRowClassName">
                <!-- <el-table-column type="index" label="编号" align="center" width="80"></el-table-column> -->
                <el-table-column prop="Id" label="类型编号" align="center" width="180"></el-table-column>
                <el-table-column prop="Name" label="类型名称" align="center" width="200"></el-table-column>
                <el-table-column prop="CreateTime" label="创建时间" align="center" sortable>
                  <template slot-scope="scope">
                    {{scope.row.CreateTime | dateYMDFormat}}
                  </template>
                </el-table-column>
                <el-table-column prop="Description" label="类型描述" align="center"></el-table-column>
                <el-table-column label="操作" align="center" width="180">
                  <template slot-scope="{row, $index}">
                      <el-button type="primary" plain size="mini" @click="ModifyVersionType(row)">编辑</el-button>
											<el-button type="primary" plain size="mini" @click="deleteVersionType(row,$index)">删除</el-button>
                  </template>
                </el-table-column>
              </el-table>
          </el-card>
        </el-main>
        <!-- 点击修改 弹窗 -->
        <el-dialog title="修改版本类型" :visible.sync="dialogModify" width="35%" >   <!-- :center="true"   居中 -->
            <div class="dialog-body">
              <el-form :model="modifyRowType" label-position="right" label-width="80px" autocomplete="off" ref="modifyRowType" :rules="Rules">
                <el-form-item label="类型编号">
                  <el-col :span="16">
                    <el-input v-model="modifyRowType.Id" placeholder="请输入类型编号" disabled></el-input>
                  </el-col>
                </el-form-item>
                <el-form-item label="类型名称" prop="Name">
                  <el-col :span="16">
                    <el-input v-model="modifyRowType.Name" placeholder="请输入类型名称"></el-input>
                  </el-col>
                </el-form-item>
                <el-form-item label="类型描述">
                  <el-col :span="16">
                    <el-input type="textarea" :autosize="{ minRows: 4, maxRows: 6}"
                              v-model="modifyRowType.Description" placeholder="请输入类型描述">
                    </el-input>
                  </el-col>
                </el-form-item>
              </el-form>
            </div>
            <div slot="footer" class="dialog-footer">
              <el-button @click="dialogModify = false">取 消</el-button>
              <el-button type="primary" @click="submitModity('modifyRowType')">确 定</el-button>
            </div>
        </el-dialog>
        <!-- 添加 -->
        <el-dialog title="添加版本类型" :visible.sync="dialogAdd" width="35%" @close="onCloseAdd">   <!-- :center="true"   居中 -->
            <div class="dialog-body">
              <el-form :model="addRowType" label-position="right" label-width="80px" autocomplete="off" ref="addRowType" :rules="Rules">
                <!-- <el-form-item label="类型编号" prop="Id">
                  <el-col :span="16">
                    <el-input v-model="addRowType.Id" placeholder="请输入类型编号" disabled></el-input>
                  </el-col>
                </el-form-item> -->
                <el-form-item label="类型名称" prop="Name">
                  <el-col :span="16">
                    <el-input v-model="addRowType.Name" placeholder="请输入类型名称"></el-input>
                  </el-col>
                </el-form-item>
                <el-form-item label="类型描述"  prop="Description">
                  <el-col :span="16">
                    <el-input type="textarea" :autosize="{ minRows: 4, maxRows: 6}"
                              v-model="addRowType.Description" placeholder="请输入类型描述">
                    </el-input>
                  </el-col>
                </el-form-item>
              </el-form>
            </div>
            <div slot="footer" class="dialog-footer">
              <el-button @click="dialogAdd = false">取 消</el-button>
              <el-button type="primary" @click="submitAdd('addRowType')">确 定</el-button>
            </div>
        </el-dialog>
      </el-container>
  </div>
</template>

<script>
  export default{
    data(){
      return{

        //软件信息 表格数据
        versionTypeData:[
          // CreateTime: "2021-07-26T16:07:58.393"
          // Description: "没有明显bug的版本,供一般客户使用"
          // Id: 1
          // Name: "稳定版"
          // SoftwareVersions: Array(0)

          // {
          //   Id: '001',  //类型编号
          //   Name: '类型名称1',   //类型名称
          //   CreateTime: "2021-07-25T07:15:36.000+0000",   //创建时间
          //   Description: '类型描述类型描述类型描述',   //类型描述
          // },
          // {
          //   Id: '002',
          //   Name: '类型名称2',
          //   CreateTime: "2021-07-25T07:15:36.000+0000",
          //   Description: '类型描述',
          // }
        ],
        //弹框样式 表单label距离左边的位置
        // formLabelWidth: '160px',
        //行索引
        index: '',
        //修改 弹窗
        dialogModify: false,
        //添加 弹窗
        dialogAdd: false,
        //编辑状态下 列表
        editList:[],
        //当前修改行信息
        modifyRowType: {},
        //添加
        addRowType: {
            Name: '',   //版本名称
            Description: '',   //版本描述
        },
        //规则
        Rules: {
          Name: [{ required: true, message: '请输入版本类型名称', trigger: 'blur'}],
        }
      }
    },
	mounted(){
	  //查询所有版本类型信息
	  this.getVersiontypeAll()
	},
	methods: {
      //查询所有版本类型信息
      getVersiontypeAll(){
          this.$http.getVersiontypeAll().then(res=>{
            // console.log(res)
            if(res.status == 200){
                this.versionTypeData = res.data
                // console.log(this.versionTypeData)
            }else{
                this.$message.error({
                  message: '查询版本类型信息失败！'
                })
            }
          })
      },
      //提交(添加)
      submitAdd(addRowType){
        //表单验证
        this.$refs[addRowType].validate((valid) => {
          if (valid) {  //验证成功 返回 true 提交数据
              //向后台提交修改信息
              let add = this.addRowType
              this.$http.addVersiontypeSingle(add).then(res=>{
                console.log(res)
                if(res.data.Code == 200){
                    this.$message.success({
                      message: '添加成功！'
                    })
                    //关闭弹框
                    this.dialogAdd = false
                    //查询所有版本类型信息
                    this.getVersiontypeAll()
                }else{
                    this.$message.error({
                      message: '添加失败！'
                    })
                }
              })
          } else {  //验证失败
            return false;
          }
        });
      },
      //添加一条软件信息按钮
      toAdd(){
        this.dialogAdd = true
      },
      //提交(修改)
      submitModity(modifyRowType){
        //表单验证
        this.$refs[modifyRowType].validate((valid) => {
          if (valid) {  //验证成功 返回 true 提交数据
              // console.log(this.modifyRowType)
              //向后台提交修改信息
              let modify = this.modifyRowType
              this.$http.setVersiontypeSingle(modify).then(res=>{
                // console.log(res)
                if(res.data.Code == 200){
                    this.$message.success({
                      message: '修改成功！'
                    })
                    //关闭弹框
                    this.dialogModify = false
                    //查询所有版本类型信息
                    this.getVersiontypeAll()

                }else{
                    this.$message.error({
                      message: '修改失败！'
                    })
                }
              })
          } else {  //验证失败
            return false;
          }
        });
      },
      //修改单条信息按钮
      ModifyVersionType(row){
        // console.log(row)
        //获取行索引  赋值本页面
        var index = row.index
        // console.log("当前行索引为：" + index)
        //构造 修改信息
        this.modifyRowType ={
            Id: row.Id,   //编号
            Name: row.Name,   //名称（必填）
            Description: row.Description,   //描述
          }
        // console.log(this.modifyRowType)
        //显示 修改弹窗
        this.dialogModify = true
      },
      // 弹窗关闭时重置表单
      onCloseAdd(){
          this.$refs['addRowType'].resetFields()
      },
      //获取 行索引
      tableRowClassName({row, rowIndex}){
        // console.log(row)
        // console.log(rowIndex)
        //把每一行的索引放进row
        row.index = rowIndex
        //赋值本页面
        this.index = rowIndex
      },
			deleteVersionType(row,index) {
				var data = "?versionTypeId=" + row.Id
				this.$confirm('此操作将永久删除该系统类型, 是否继续?', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					// console.log(data);
					this.$http.deleteVersionType(data).then(res => {
						if (res.data.Code != 200) return this.$message.error(res.data.MsgText)
						this.$message.success("删除成功")
						this.versionTypeData.splice(index, 1)
					})
				})
			}
    }
  }

</script>

<style>
  .pagesContent{
    width: 100%;
    height: 100%;
  }
  /* 对话框 */
  .dialog-body{
      /* height: 36vh; */
      /* box-sizing: border-box; */
      padding: 0 40px 0 80px;
  }
	.el-textarea__inner{
	  font-family: "Helvetica Neue",Helvetica,"PingFang SC","Hiragino Sans GB","Microsoft YaHei","微软雅黑",Arial,sans-serif;
  }
</style>
